export const validation =   {
  title: { required: true },
  titleMaxChar: 60,
  paragraphMaxChar: 100,
  blockTitleMaxChar: 50,
  videos: {
    min: 1,
    max: 12
  }
}